if (!customElements.get('cart-upsell-product')) {
  class CartUpsellProduct extends HTMLElement {
    constructor() {
      super();

      const variantsScript = this.querySelector('[data-upsell-variants]');
      this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

      this.selects = Array.from(this.querySelectorAll('.cart-upsell-item__select')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );

      this.priceElement = this.querySelector('[data-upsell-price]');
      this.errorElement = this.querySelector('[data-upsell-error]');
      this.addButton = this.querySelector('[data-upsell-add]');
      this.addButtonText = this.querySelector('[data-upsell-add-text]');
      this.spinner = this.querySelector('.loading__spinner');

      this.selects.forEach((select) => select.addEventListener('change', this.updateVariant.bind(this)));
      if (this.addButton) this.addButton.addEventListener('click', this.addToCart.bind(this));

      this.updateVariant();
    }

    getSelectedOptions() {
      return this.selects.map((select) => select.value);
    }

    findMatchingVariant() {
      if (this.selects.length === 0) {
        return this.variants.find((variant) => variant.available) || this.variants[0];
      }
      const selectedOptions = this.getSelectedOptions();
      return this.variants.find((variant) =>
        variant.options.every((optionValue, index) => optionValue === selectedOptions[index])
      );
    }

    updateVariant() {
      const variant = this.findMatchingVariant();
      this.currentVariant = variant;

      if (!variant) {
        this.setError(window.cartStrings && window.cartStrings.unavailable ? window.cartStrings.unavailable : 'This combination is currently unavailable');
        if (this.addButton) this.addButton.disabled = true;
        return;
      }

      this.clearError();

      if (this.priceElement) {
        this.priceElement.textContent = this.formatMoney(variant.price);
      }

      if (this.addButton) {
        this.addButton.disabled = !variant.available;
      }

      if (!variant.available) {
        this.setError(window.cartStrings && window.cartStrings.soldOut ? window.cartStrings.soldOut : 'Sold out');
      }
    }

    setError(message) {
      if (!this.errorElement) return;
      this.errorElement.textContent = message;
      this.errorElement.hidden = false;
    }

    clearError() {
      if (!this.errorElement) return;
      this.errorElement.textContent = '';
      this.errorElement.hidden = true;
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
        return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    setLoading(isLoading) {
      if (!this.addButton) return;
      this.addButton.disabled = isLoading;
      this.addButton.classList.toggle('loading', isLoading);
      if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
      if (this.addButtonText) this.addButtonText.classList.toggle('hidden', isLoading);
    }

    addToCart() {
      if (!this.currentVariant || !this.currentVariant.available) return;

      this.setLoading(true);
      this.clearError();

      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];

      const addUrl = window.routes && routes.cart_add_url ? `${routes.cart_add_url}.js` : '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: this.currentVariant.id, quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.setError(response.description || response.message || 'Could not add this item to your cart.');
            return;
          }

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: response });
          }

          document.dispatchEvent(
            new CustomEvent('cart:upsell-added', { detail: { variantId: this.currentVariant.id } })
          );
        })
        .catch((error) => {
          console.error(error);
          this.setError('Something went wrong. Please try again.');
        })
        .finally(() => {
          this.setLoading(false);
        });
    }
  }

  customElements.define('cart-upsell-product', CartUpsellProduct);
}
